import React from "react";

const SkillItem = (props) => {
  const { title, percentage } = props.skill;
  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-2">
        <h5 className="text-sm md:text-base text-gray-700 font-medium">{title}</h5>
        <span className="text-sm font-semibold text-green-600">
          {percentage}
        </span>
      </div>
      <div className="w-full bg-green-100/50 backdrop-blur-sm relative h-2.5 rounded-full overflow-hidden border border-green-200/30">
        <div
          className="absolute h-full left-0 top-0 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full transition-all duration-500"
          style={{ width: `${percentage}` }}
        />
      </div>
    </div>
  );
};

export default SkillItem;
